import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import BillJournalView from 'components/billing/bill-journal/BillJournalView';
import BillTextView from 'components/billing/bill-text/BillTextView';
import CollectiveBillView from 'components/billing/collective-bill/CollectiveBillView';
import InvoiceStatistic2View from 'components/billing/invoice-statistic/InvoiceStatistic2View';
import InvoiceStatisticView from 'components/billing/invoice-statistic/InvoiceStatisticView';
import MisantoImportView from 'components/billing/misanto-import/MisantoImportView';
import OpenItemListView from 'components/billing/open-item-list/OpenItemListView';
import PatientMergingView from 'components/billing/patient-merging/PatientMergingView';
import PaymentJournalView from 'components/billing/payment-journal/PaymentJournalView';
import WeekPricesView from 'components/billing/week-price/WeekPricesView';
import SectionContainer from 'components/section/SectionContainer';
import { SectionPage } from 'components/section/SectionPage';
import DayStatisticView from 'components/statistic/day-statistic/DayStatisticView';
import ProcedureStatisticView from 'components/statistic/procedure-statistic/ProcedureStatisticView';
import React from 'react';
import { Privilege } from 'ts-types/api.enums';

interface Props extends AuthConsumerRenderProps {

}

const BillingHome = (props: Props) => {
  let pages: SectionPage[] = [
    {id: "billTexts", uri: "/billing/bill-texts", component: BillTextView},
    {id: "collectiveBill", uri: "/billing/collective-bill", component: CollectiveBillView},
    {id: "billJournal", uri: "/billing/bill-journal", component: BillJournalView},
    {id: "paymentJournal", uri: "/billing/payment-journal", component: PaymentJournalView},
    {id: "openItemList", uri: "/billing/open-item-list", component: OpenItemListView},
    {id: "invoiceStatistic", uri: "/billing/invoice-statistic", component: InvoiceStatisticView},
    {id: "invoiceStatistic2", uri: "/billing/invoice-statistic-2", component: InvoiceStatistic2View},
    {id: "dayStatistic", uri: "/billing/day-statistic", component: DayStatisticView},
    {id: "procedureStatistic", uri: "/billing/procedure-statistic", component: ProcedureStatisticView}
  ];

  const userRoles = props.currentUser ? props.currentUser.roles : [];
  const misantoImportEnabled = props.currentUserHasPrivilege(Privilege.PX_CORE_MISANTO_IMPORT);
  const isMandateAdmin = userRoles.includes("ROLE_MANDATE_ADMIN");
  const isAppAdmin = userRoles.includes("ROLE_APP_ADMIN");
  const mergePrivilege = props.currentUserHasPrivilege(Privilege.PX_CORE_PATIENT_MERGE);

  if (isAppAdmin || isMandateAdmin || mergePrivilege) {
    pages.push({id: "patientMerging", uri: "/billing/patient-merging", component: PatientMergingView});
  }
  if (misantoImportEnabled || isAppAdmin) {
    pages.push({id: "misantoImport", uri: "/billing/misanto-import", component: MisantoImportView});
  }

  if (isMandateAdmin) {
    pages.push({id: "weekPrices", uri: "/billing/week-prices", component: WeekPricesView});
  }

  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withAuthContext(BillingHome);
